import { Skeleton } from '@material-ui/lab';
import classNames from 'clsx';
import React from 'react';

import styles from './Results.scss';

const ResultsSkeleton = () => (
  <>
    <Skeleton className={classNames(styles.skeleton, styles.textSkeleton)} variant="text" />
    {Array.from({ length: 5 }).map((_, index) => (
      <Skeleton key={`results-skeleton-${index}`} className={styles.skeleton} variant="rect" />
    ))}
  </>
);

export default ResultsSkeleton;
